module.exports = __webpack_public_path__ + "img/NUM.5dec7c43.svg";